<template>
    <div class="filter-wrap" v-for="param in params" v-bind:id="'filter-wrap-'+param.id">
        <div class="box" v-if="Object.keys(param.values).length > 0">
            <h4>{{ param.name }}</h4>
            <div class="custom-checkbox js-property"
                 v-for="val in productCategories(param).slice(0, 5)"
                 :key="val.id">
                <label>
                    <input type="checkbox"
                           :name="'properties['+param.id+'][]'"
                           :value="val.id"
                           @change="$emit('onParamChanged')">
                    <span class="check"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg></span>
                    <span class="label">{{ val.value }} {{ param.mu }}</span>
                </label>
            </div>

            <div class="custom-checkbox js-property d-none"
                 v-for="val in productCategories(param).slice(5)"
                 :key="val.id">
                <label>
                    <input type="checkbox"
                           :name="'properties['+param.id+'][]'"
                           :value="val.id"
                           @change="$emit('onParamChanged')">
                    <span class="check"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg></span>
                    <span class="label">{{ val.value }} {{ param.mu }}</span>
                </label>
            </div>
        </div>

        <div class="divider" :id="'divider-'+param.id"
             v-if="productCategories(param).length > 5"
             @click="showAllFilters(param.id);">
            <h5>
                <span>{{ allParams }}</span>
            </h5>
        </div>
    </div>
</template>

<script>
import {defineComponent, onMounted, ref} from 'vue'
import lodash from 'lodash'
import {removeClassBySelector} from '../../functions/removeClassBySelector'
import emitter from '../../utils/emitter'

export default defineComponent({
    props: [
        'title',
        'allParams',
        'params'
    ],

    methods: {
        productCategories: function (item) {
            return lodash.uniqBy(item.values, 'value')
        },

        showAllFilters: function (id) {
            //document.querySelectorAll('#'+id+' .custom-checkbox').removeClass('d-none');
            let filters = document.querySelectorAll('#filter-wrap-' + id + ' .custom-checkbox')
            let divider = document.getElementById('divider-' + id)
            filters.forEach(function (filter) {
                filter.classList.remove("d-none");
            });

            divider.style.display = 'none'
        }
    },

    setup() {
        const allVisible = ref(false)

        onMounted(() => {
            emitter.on('setValuesFromParameters', ({properties}) => {
                if (properties && properties.length > 0)
                    handleCheckedInputs(JSON.parse(properties))
            })
        })

        function handleCheckedInputs(Ids) {
            Array.from(document.querySelectorAll('.js-property input')).forEach((input) => {
                if (Ids.includes(input.value))
                    input.checked = true
            })
        }

        return {
            handleCheckedInputs,
            removeClassBySelector,
            allVisible
        }
    }
})
</script>
